<script lang="ts">
  import Modal from "@ui/Modal.svelte";
  import { postJson } from "@ui/http";
  import { validateEmail } from "./utils";
  import { onMount } from "svelte";

  export let isOpen: boolean = false;
  export let listId: string;

  let fullName: string = "";
  let email: string = "";

  function closePopup() {
    isOpen = false;
  }

  async function doSubscribe() {
    if (canSend) {
      const result = await postJson<{ errorMessage?: string }>("/app/flyer_actions/subscribe_to_author_json", {
        list_id: listId,
        email,
        name: fullName
      });

      if (result.errorMessage) {
        alert(result.errorMessage);
      }
      isOpen = false;
    }
  }

  $: canSend = fullName.trim().length > 0 && validateEmail(email);

  $: if (isOpen) {
    email = "";
    fullName = "";
  }
</script>

<div class="z-10">
  <Modal bind:isOpen --popup-width="400px">
    <div class="flex flex-col justify-center w-full mt-4">
      <div class="flex flex-col items-center justify-between w-full">
        <label class="flex flex-col w-full text-sm font-medium">
          <span>Full name <span class="text-red-500">*</span></span>
          <input type="text" bind:value={fullName} autofocus />
        </label>
        <label class="flex flex-col w-full mt-4 text-sm font-medium">
          <span>Your email <span class="text-xs text-nxgray-300">(so they can reach you)</span><span class="text-red-500">*</span></span>
          <input type="email" bind:value={email} />
        </label>
      </div>
      <div class="flex justify-end w-full">
        <button
          class="px-3 py-1 mt-4 text-sm text-white rounded outline-none focus:outline-none"
          class:bg-green-500={canSend}
          class:clickable={canSend}
          class:shadow={canSend}
          class:bg-gray-400={!canSend}
          on:click={doSubscribe}>Subscribe</button>
      </div>
    </div>
  </Modal>
</div>

<style>
  input {
    border-radius: theme("borderRadius.DEFAULT");
    border-color: theme("borderColor.DEFAULT");
    border-width: theme("borderWidth.DEFAULT");
    padding-left: theme("padding.2");
    padding-right: theme("padding.2");
    padding-top: theme("padding.1");
    padding-bottom: theme("padding.1");
    width: 100%;
  }
</style>
